import { render, staticRenderFns } from "./NewGoods.vue?vue&type=template&id=20e98882&scoped=true"
import script from "./NewGoods.vue?vue&type=script&lang=js"
export * from "./NewGoods.vue?vue&type=script&lang=js"
import style0 from "./NewGoods.vue?vue&type=style&index=0&id=20e98882&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e98882",
  null
  
)

export default component.exports